import OperationsIcon from '../assets/Operations';
import FlightAllocationIcon from '../assets/FlightAllocation';
import BusPickupAllocation from '../assets/BusPickupAllocation';
import BusDropOffAllocation from '../assets/BusDropOffAllocation';
import BookingAllocation from '../assets/BookingsIcon';
import HomeIcon from '../assets/icon/HomeIcon';
import PassengerManifest from '../assets/icon/PassengerManifest';

//TODO: // I will update this according to figma design later
export const navigationItems = [
  {
    icon: <HomeIcon color={'var(--sideBarTextColor)'} />,
    label: 'Home',
    id: 10,
    url: '/',
    showOnMobile: false, // Visible on desktop
  },
  {
    icon: <OperationsIcon color={'var(--sideBarTextColor)'} />,
    label: 'Daily Operations',
    id: 2,
    url: '/operations',
    showOnMobile: false, // Visible on desktop
  },
  {
    icon: <FlightAllocationIcon color={'var(--sideBarTextColor)'} />,
    label: 'Flight Allocation',
    id: 4,
    url: '/flightAllocation',
    showOnMobile: false,
  },
  {
    icon: <BusPickupAllocation color={'var(--sideBarTextColor)'} />,
    label: 'Pickup Bus Allocation',
    id: 6,
    url: '/pickupAllocation',
    showOnMobile: false,
  },
  {
    icon: <BusDropOffAllocation color={'var(--sideBarTextColor)'} />,
    label: 'DropOff Bus Allocation',
    id: 5,
    url: '/dropoffAllocation',
    showOnMobile: false,
  },
  {
    icon: <BookingAllocation color={'var(--sideBarTextColor)'} />,
    label: 'View Bookings',
    id: 7,
    url: '/bookings',
    showOnMobile: false,
  },
  {
    icon: <BookingAllocation color={'var(--sideBarTextColor)'} />,
    label: 'Calendar',
    id: 8,
    url: '/calendar',
    showOnMobile: true, // Only visible on mobile
  },
  {
    icon: <PassengerManifest color={'var(--sideBarTextColor)'} />,
    label: 'Passenger Manifest',
    id: 9,
    url: '/passengerManifest',
    showOnMobile: false, // Visible on both desktop and mobile
  },
];
